@if (!isMobile && !isMinimized) {
    <div class="bin-live-info-container">
        <div class="header-container" rtlDiv>
            <div class="header-left-container">
                @if(selectedBinInfo) {
                    <img class="refresh-icon" src="assets/images/binInfoPage/last_time_update_icon.svg" alt="last_time_updated" />
                    {{'LIVE_INFO.LIVE_LAST_UPDATE' | translate }} {{calcDiff(selectedBinInfo?.Bin_live_Data.Transmission_data.last_transmission_time)}}
                }
            </div>
            <div class="header-right-container" rtlDiv>
                @if(user_role_id != 8) {
                    <div class="menu-Cmp" rtlDiv>
                        <div class="dropdown-toggle" data-bs-toggle="dropdown">
                            <img class="three-dots" alt="three-dots" src="assets/images/dashboard/threedots.svg">
                        </div>
                        <div class="dropdown-menu list-items" rtlDiv>
                            <!-- <div class="menuItem">
                                <span class="item-txt" (click)="compareBins()">
                                    <div class="item-txt-container">
                                        <img alt="compare" src="assets/images/binInfoPage/compare.svg">
                                        {{'LIVE_INFO.COMPARE_BINS' | translate}}
                                    </div>
                                </span>
                            </div>                         -->
                            <div class="menuItem">
                                <div class="item-txt" rtlDiv (click)="editBin()">
                                    <span>{{ 'LIVE_INFO.EDIT_BIN' | translate }}</span>
                                    <span>&nbsp;</span>
                                    <span class="item-txt-bin-name">{{selectedBinInfo?.bin_name}}</span>
                                </div>
                            </div>   
                            @if(tabs.length > 1){
                                <div class="menuItem">
                                    <span class="item-txt" (click)="manageBins()">{{ 'LIVE_INFO.MANAGE_BINS' | translate }}</span>
                                </div> 
                            }                                       
                        </div>
                    </div>
                }
                <img (click)="minimizeModal()" class="minimize-img" src="assets/images/binInfoPage/minimize.svg" alt="minimize" />
                <img (click)="closeModal()" class="close-img" src="assets/images/reports/close.svg" alt="close">
            </div>
        </div>
        <mat-tab-group [dir]="currentLang ? (currentLang == 'iw' ? 'rtl' : 'ltr') : 'auto'" #matTabGroupBins class="tab-group" mat-stretch-tabs="false" rtlDiv animationDuration="0ms" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="binTabChanged($event)">
            @for(tab of tabs;track tab; let i = $index){
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab-label-container" rtlDiv>
                            <span>{{ tab.bin_name }}</span>
                            @if(tabs.length > 1){
                                <img (click)="removeTab(i)" class="close-img-remove" src="assets/images/reports/close.svg" alt="close">
                            }
                        </div>
                    </ng-template>
                    <div class="tab-content">
                        <div class="tab-content-header">
                            <div class="tab-info-container">
                                <div class="tab-info-title-container">
                                    <div class="tab-info-title">{{'SITE_MANAGMENT.BIN_NAME' | translate }}</div>
                                </div>
                                <div class="tab-info-value">{{selectedBinInfo?.bin_name}}</div>
                            </div>
                            <div class="tab-info-container">
                                <div class="tab-info-title-container">
                                    <img alt="bin-id" src="assets/images/binInfoPage/bin-id.svg">
                                    <div class="tab-info-title">{{'LIVE_INFO.BIN_ID' | translate }}</div>
                                </div>
                                <div class="tab-info-value">{{selectedBinInfo?.bin_id}}</div>
                                <img (click)="copyToClipboard(selectedBinInfo?.bin_id)" class="copy-icon" src="assets/images/binInfoPage/copy.svg" alt="copy">
                            </div>
                            @if(user_role_id == 5 || user_role_id == 6) {
                                <div class="tab-info-container">
                                    <div class="tab-info-title-container">
                                        <img alt="bin-id" src="assets/images/binInfoPage/bin-id.svg">
                                        <div class="tab-info-title">{{'SITE_MANAGMENT.DEVICE_ID' | translate }}</div>
                                    </div>
                                    <div class="tab-info-value">{{selectedBinInfo?.device_id}}</div>
                                    <img (click)="copyToClipboard(selectedBinInfo?.device_id)" class="copy-icon" src="assets/images/binInfoPage/copy.svg" alt="copy">
                                </div>
                            }
                            <div class="tab-info-container">
                                <div class="tab-info-title-container">
                                    <img alt="bin" src="assets/images/binInfoPage/bin.svg">
                                    <div class="tab-info-title">{{'INSIGHTS.BIN_TYPE' | translate }}</div>
                                </div>
                                <div class="tab-info-value">{{selectedBinInfo?.bin_type_name}}</div>
                            </div>
                            <div class="tab-info-container">
                                <div class="tab-info-title-container">
                                    <img alt="location-pin" src="assets/images/binInfoPage/location-pin.svg">
                                    <div class="tab-info-title">{{'TICKET_MANAGEMENT.SITE' | translate }}</div>
                                </div>
                                <div class="tab-info-value">{{selectedBinInfo?.site_name}}</div>
                            </div>
                        </div>
                        <div class="tab-content-body">
                            <div class="tab-content-body-tabs-headers">
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 0}" class="tab-content-item" (click)="tabChanged(0)">{{'LIVE_INFO.KPIS' | translate}}</span>
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 1}" class="tab-content-item" (click)="tabChanged(1)">{{'LIVE_INFO.CAPACITY_CHART' | translate}}</span>
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 2}" class="tab-content-item" (click)="tabChanged(2)">{{'LIVE_INFO.COLLECTION' | translate}}</span>
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 3}" class="tab-content-item" (click)="tabChanged(3)">{{'LIVE_INFO.LOCATION' | translate}}</span>
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 4}" class="tab-content-item" (click)="tabChanged(4)">{{'LIVE_INFO.LIVE_EVENTS' | translate}}</span>
                                <span rtlDiv [ngClass]="{'tab-content-item-active': tabContentItemIndex == 5}" class="tab-content-item" (click)="tabChanged(5)">{{'LIVE_INFO.TICKETS' | translate}}</span>
                            </div>
                            <div class="tab-content-body-tabs" rtlDiv>             
                                @if (selectedTabIndex === i) {
                                    <div id="bin-content-0" class="tab-content-body-tabs-content">
                                        <app-bin-metrics></app-bin-metrics>
                                    </div>
                                    <div id="bin-content-1" class="tab-content-body-tabs-content">
                                        <app-bin-capacity></app-bin-capacity>
                                    </div>
                                    <div id="bin-content-2" class="tab-content-body-tabs-content">
                                        <app-bin-collection></app-bin-collection>
                                    </div>
                                    <div id="bin-content-3" class="tab-content-body-tabs-content">
                                        <app-bin-location></app-bin-location>
                                    </div>
                                    <div id="bin-content-4" class="tab-content-body-tabs-content">
                                        <app-bin-events></app-bin-events>
                                    </div>
                                    <div id="bin-content-5" class="tab-content-body-tabs-content">
                                        <app-bin-tickets></app-bin-tickets>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </mat-tab>
             }
             <mat-tab>
                <ng-template mat-tab-label>
                    <img src="assets/images/binInfoPage/plus-new.svg" alt="add-bin">
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
}

@if (isMobile) {

}

@if (isMinimized) {
    <div class="minimized-modal-container">
        <div class="minimized-header">
            <div class="minimized-header-content">
                <span class="minimized-title">{{getMinimizedTitle()}}</span>
                <span class="minimized-remaining-tabs-count">{{getMinimizedRemainingTabsCount()}}</span>
            </div>
            <div class="minimized-header-options">
                <img (click)="maximizeModal()" class="maximize-img" src="assets/images/binInfoPage/maximize.svg" alt="maximize" />
                <img (click)="closeModal()" class="maximize-img" src="assets/images/reports/close.svg" alt="close">
            </div>
        </div>
    </div>
}